import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IStoreState } from "../initialStoreState";
import { ILead } from "../leads/leads.types";
import {
  saveLoaderProgress,
  showMessage,
  saveLoaderCompleted,
} from "../messages/messagesActions";
import { fetchLeadProgress } from "../leads/leadsActions";
import { IFeeStructure } from "./feeStructure.types";

export const FETCH_FEE_LIST_PROGRESS = "FETCH_FEE_LIST_PROGRESS";
export const FETCH_FEE_LIST_SUCCESS = "FETCH_FEE_LIST_SUCCESS";
export const FETCH_FEE_LIST_FAILED = "FETCH_FEE_LIST_FAILED";

export const fetchFeeStructureListProgress = () =>
  action(FETCH_FEE_LIST_PROGRESS);
export const fetchFeeStructureListSuccess = (
  list: IFeeStructure[],
  totalRecords: number
) => action(FETCH_FEE_LIST_SUCCESS, { list, totalRecords });
export const fetchFeeStructureListFailed = (errorMessage: string) =>
  action(FETCH_FEE_LIST_FAILED, { errorMessage });

export const fetchFeeStructureListAsync =
  (
    UUID: { courseUUID: string; organizationUUID?: string; batch?: string },
    pageNumber: number,
    rowsInPerPage: number,
    searchValue: IDatatableV2AdvancedSearchFilter,
    customerFactUUID?: string,
    academicYear?: string | null,
    status?: string | null
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchFeeStructureListProgress());
      dispatch(saveLoaderProgress());

      let url = "";
      if (customerFactUUID) {
        url += `&customer_fact_uuid=${customerFactUUID}`;
      }
      if (UUID.organizationUUID) {
        url += `&organizations_uuid=${UUID.organizationUUID}`;
      }
      if (UUID.batch) {
        url += `&batch=${UUID.batch}`;
      }
      if (academicYear) {
        url += `&academic_year=${academicYear}`;
      }
      if (status !== "-1") {
        url += `&status=${status}`;
      }

      const finalUrl =
        `/master/get-fee-detailed-structure?courses_uuid=${UUID.courseUUID}&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}` +
        url;

      const res = await api.get(finalUrl);
      const data = res.data.data;
      const totalRecords = res.data.totalRecords;
      if (data.length > 0) {
        dispatch(fetchFeeStructureListSuccess(data, totalRecords));
      }
    } catch (err: any) {
      dispatch(fetchFeeStructureListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

//**********************************upsert fee transition start********************************** */

export const upsertfeeStructureAysnc =
  (
    existingLead: IFeeStructure,
    onCallBack: (isSuccess?: boolean, data?: IFeeStructure) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    // dispatch(saveLoaderProgress());

    try {
      const {
        fee_structure_id,
        fee_structure_unique_id,
        create_ts,
        created_by_name,
        created_by_uuid,
        modified_by_name,
        modified_by_uuid,
        insert_ts,
        fee_override_uuid,
        total_fee_amount,
        pending_fee,
        fees_paid,
        custom_fee_type,
        fine_amount,
        ...rest
      } = existingLead;
      console.log(rest);

      const res = await api.post("/master/upsert-fee-structure", {
        ...rest,
        fee_type: custom_fee_type || rest.fee_type,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Fee saved succesfully!",
          displayAs: "snackbar",
        })
      );
      const data = res.data.data;
      onCallBack(true, data);
    } catch (err: any) {
      onCallBack(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      // dispatch(saveLoaderCompleted());
    }
  };

//******************************************upsert fee transition end********************************** */

//*************************fee over riding start************************** */
export const upsertfeeStructureOverridingAysnc =
  (
    existingLead: IFeeStructure,
    id: string,
    onCallBack: (isSuccess?: boolean, data?: IFeeStructure) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(saveLoaderProgress());

    try {
      const {
        fee_structure_id,
        fee_structure_unique_id,
        create_ts,
        created_by_name,
        created_by_uuid,
        modified_by_name,
        modified_by_uuid,
        insert_ts,
        total_fee_amount,
        fees_paid,
        pending_fee,
        is_optional,
        ...rest
      } = existingLead;
      console.log(rest);

      const res = await api.post("/master/upsert-fee-override", {
        ...rest,
        customer_fact_uuid: id,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Fee saved succesfully!",
          displayAs: "snackbar",
        })
      );
      const data = res.data.data;
      onCallBack(true, data);
    } catch (err: any) {
      onCallBack(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

//**************************fee over riding end************************** */

export const CLEAR_FEE_STATE = "CLEAR_FEE_STATE";
export const CLEAR_FEE = "CLEAR_FEE";

export const clearFeeStructureState = () => action(CLEAR_FEE_STATE);
export const clearfeeStructure = () => action(CLEAR_FEE);
